import { render } from "./FormFieldOption.vue?vue&type=template&id=84abfbdc&scoped=true"
import script from "./FormFieldOption.vue?vue&type=script&lang=js"
export * from "./FormFieldOption.vue?vue&type=script&lang=js"

import "./FormFieldOption.vue?vue&type=style&index=0&id=84abfbdc&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84abfbdc"]])

export default __exports__